// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"3dc9215d35d944a27b70","678":"b6c3934b3d5983b8b69a"}[chunkId] + ".js";
};